<div class="form-input" [formGroup]="group" class="{{config.size.toString()}}" *ngIf="isVisible">
    <label for="{{config.fieldInfo.name}}" [ngClass]="{'label': inline}">{{config.fieldInfo.caption}}</label>
    <label [ngClass]="{'inline-field': inline}">            
        <mat-radio-group [ngClass]="{'wtf-radio-group': !inline}" [(ngModel)]="optionSelected" [formControlName]="config.fieldInfo.name">
            <mat-radio-button class="wtf-radio" *ngFor="let option of options | async" [value]="option[idPropertyName]">{{option[valuePropertyName]}}</mat-radio-button>
        </mat-radio-group>
    </label>
</div>